import React from 'react';
import {
    Box, Typography, FormControlLabel,
    Radio, RadioGroup, Switch, IconButton
} from '@mui/material';
import {
    AltRouteOutlined, CloseOutlined, LayersOutlined, LocalShippingOutlined,
    PlaceOutlined, SatelliteAltOutlined, StopCircleOutlined, WarehouseOutlined
} from '@mui/icons-material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    layerlabel: {
        color: '#000',
        fontSize: 13,
    },
    Mainlayerbox: {
        position: 'absolute',
        top: 100,
        left: 54,
        zIndex: 1000,
        backgroundColor: '#fff',
        color: '#000',
        padding: '10px 16px',
        borderRadius: 2,
        width: 210,
    }
});

interface Props {
    showStops: boolean;
    showDepots: boolean;
    showTouren: boolean;
    showPickup: boolean;
    showDelivery: boolean;
    selectedBase: string;
    visibleTours: Record<string, boolean>;
    onToggleTourVisibility: (tourId: string) => void;
    onToggleStops: () => void;
    onToggleDepot: () => void;
    onToggleTouren: () => void;
    onTogglePickup: () => void;
    onToggleDelivery: () => void;
    onChangeBase: (base: string) => void;
    onClose: () => void;
}

export default function LayersPanelDetails({
    showStops,
    showDepots,
    showTouren,
    showPickup,
    showDelivery,
    selectedBase,
    visibleTours,
    onToggleTourVisibility,
    onToggleStops,
    onToggleDepot,
    onToggleTouren,
    onTogglePickup,
    onToggleDelivery,
    onChangeBase,
    onClose,
}: Props) {
    const classes = useStyles();
    return (
        <Box className={classes.Mainlayerbox}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography fontWeight="bold">Layers</Typography>
                <IconButton onClick={onClose} size="small" sx={{ color: '#eee' }}>
                    <CloseOutlined />
                </IconButton>
            </Box>

            <Typography variant="caption" color="gray" fontWeight="bold">
                OVERLAYS
            </Typography>
            <Box display="flex" alignItems="center" justifyContent="space-between" my={0}>
                <Box display="flex" alignItems="center" gap={1}>
                    <StopCircleOutlined fontSize="small" />
                    <Typography className={classes.layerlabel}>Stops</Typography>
                </Box>
                <Switch checked={showStops} onChange={onToggleStops} color="primary" />
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between" my={0}>
                <Box display="flex" alignItems="center" gap={1}>
                    <WarehouseOutlined fontSize="small" />
                    <Typography className={classes.layerlabel}>Depots</Typography>
                </Box>
                <Switch checked={showDepots} onChange={onToggleDepot} color="primary" />
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between" my={0}>
                <Box display="flex" alignItems="center" gap={1}>
                    <AltRouteOutlined fontSize="small" />
                    <Typography className={classes.layerlabel}>Touren</Typography>
                </Box>
                <Switch checked={showTouren} onChange={onToggleTouren} color="primary" />
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between" my={0}>
                <Box display="flex" alignItems="center" gap={1}>
                    <PlaceOutlined fontSize="small" />
                    <Typography className={classes.layerlabel}>Pickups</Typography>
                </Box>
                <Switch checked={showPickup} onChange={onTogglePickup} color="primary" />
            </Box>

            <Box display="flex" alignItems="center" justifyContent="space-between" my={0}>
                <Box display="flex" alignItems="center" gap={1}>
                    <PlaceOutlined fontSize="small" />
                    <Typography className={classes.layerlabel}>Deliveries</Typography>
                </Box>
                <Switch checked={showDelivery} onChange={onToggleDelivery} color="primary" />
            </Box>
            <Typography variant="caption" color="gray" fontWeight="bold">
                TOURS
            </Typography>
            {Object.entries(visibleTours).map(([tourId, isVisible]) => (
                <Box key={tourId} display="flex" justifyContent="space-between" alignItems="center" my={0}>
                    <Typography className={classes.layerlabel}>{tourId}</Typography>
                    <Switch
                        checked={!!isVisible}
                        onChange={() => onToggleTourVisibility(tourId)}
                        color="primary"
                    />
                </Box>
            ))}
            <Box mt={0}>
                <Typography variant="caption" color="gray" fontWeight="bold">
                    BASE LAYERS
                </Typography>
                <RadioGroup
                    value={selectedBase}
                    onChange={(e) => onChangeBase(e.target.value)}
                    name="base-layers"
                >
                    <FormControlLabel
                        value="Standard"
                        control={<Radio color="primary" />}
                        label={<Box display="flex" alignItems="center"
                            gap={1} className={classes.layerlabel}>
                            <LayersOutlined fontSize="small" /> Standard</Box>}
                    />
                    <FormControlLabel
                        value="LKW"
                        control={<Radio color="primary" />}
                        label={<Box display="flex" alignItems="center"
                            gap={1} className={classes.layerlabel}>
                            <LocalShippingOutlined fontSize="small" /> LKW</Box>}
                    />
                    <FormControlLabel
                        value="Satellit"
                        control={<Radio color="primary" />}
                        label={<Box display="flex" alignItems="center"
                            gap={1} className={classes.layerlabel}>
                            <SatelliteAltOutlined fontSize="small" /> Satellit</Box>}
                    />
                </RadioGroup>
            </Box>
        </Box>
    );
}